import { render } from "./zhengcCreate.vue?vue&type=template&id=ef4274f2"
import script from "./zhengcCreate.vue?vue&type=script&lang=js"
export * from "./zhengcCreate.vue?vue&type=script&lang=js"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__